/**
 * Replaces app/plugins/sentry.client.ts (removed - see
 * NUXT4-MIGRATION-PROGRESS.md Phase 4). @sentry/nuxt/module dynamically
 * imports this file from within its own Nuxt plugin, which is what makes
 * useRuntimeConfig() usable here even though this isn't a defineNuxtPlugin
 * file itself.
 *
 * Do NOT add `app` or `browserTracingIntegration({ router })` here - the
 * module's own auto-registered plugin (runtime/plugins/sentry.client.js)
 * already adds both automatically once Sentry.init() below creates a
 * client, keyed off `nuxtApp.$router` and the `app:created` hook.
 */
import * as Sentry from '@sentry/nuxt';

const { public: { sentry, environment } } = useRuntimeConfig();

// If disabled and environment is development, ignore and warn in the console
const disabledInDevelopment = true;
if (!sentry.dsn || (environment === 'development' && disabledInDevelopment)) {
  console.warn('Sentry DSN not set, skipping Sentry Client initialization');
} else {
  Sentry.init({
    dsn: sentry.dsn,
    environment,
    integrations: [
      Sentry.replayIntegration(),
    ],

    tracesSampleRate: 0.02,

    tracePropagationTargets: ['localhost'],

    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.02,
  });
}
